module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"title":"Neue Adresse hinzufügen","btn-save":"Speichern","field-required":"Pflichtfeld"},"fr":{"title":"Ajouter une nouvelle adresse","btn-save":"Sauvegarder","field-required":"Champ obligatoire"},"it":{"title":"Aggiungere nuovo indirizzo","btn-save":"Salvare","field-required":"Campo obbligatorio"}}')
  delete Component.options._Ctor
}
